module.exports = __webpack_public_path__ + "fonts/Rubik-500-cyrillic-ext20.f2f7a74.woff2";